module.exports = __webpack_public_path__ + "static/media/playstore-6e.1e39a3ad.png";